import React, { useState, useContext, useRef, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Image } from 'semantic-ui-react';
import { useLazyQuery } from '@apollo/react-hooks';
import { withTranslation } from 'react-i18next';
import SelectLanguage from '../../common/SelectLanguage';
import lang from '../../utils/translations';
import { AuthContext } from '../../context/auth';
import SearchModal from '../SearchModal';
import { Container, Nav, Navbar, Overlay, Popover, Card } from 'react-bootstrap';
import PopoverContent from 'react-bootstrap/PopoverContent';
import { motion } from 'framer-motion';
import moment from 'moment';
import './notification.scss';

import { IoPhonePortraitOutline, IoCartOutline, IoNotificationsOutline } from 'react-icons/io5';
import white_logo from '../../assets/HAAPA Final Logo_White-01.png';
import { FETCH_ALL_BOOKS_IN_MY_CART, FETCH_ALL_MY_NOTIFICATIONS } from '../../graphql/query';
import {
  RiBook3Line,
  RiDashboardLine,
  RiFacebookCircleLine,
  RiHealthBookLine,
  RiInstagramLine,
  RiLoginCircleLine,
  RiLogoutCircleLine,
  RiMailSendLine,
  RiSearchLine,
  RiShieldUserLine,
  RiTwitterLine,
  RiUserAddLine,
} from 'react-icons/ri';
import { FaRegUserCircle } from 'react-icons/fa';
import { MdLibraryBooks } from 'react-icons/md';
import { NavigationMenu } from '../../utils/AuthRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import './MainHeader.scss';

const MainHeader = () => {
  const { user, logout } = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const searchRef = useRef();

  const [showAlert, setShowAlert] = useState('none');
  const showNotification = () => {
    setShowAlert('none');
  }
  
  const toggleNotification = () => {
    setShowAlert('block');
  }

  const handleClick = event => {
    setShow(!show);
    setTarget(event.target);
  };

  const [allBooksInMyCart, { data }] = useLazyQuery(FETCH_ALL_BOOKS_IN_MY_CART, {
    context: {
      headers: {
        authorization: localStorage.getItem('token'),
      },
    },
  });
  const [getAllMyNotifications, { data: dataNotifications }] = useLazyQuery(FETCH_ALL_MY_NOTIFICATIONS, {
    context: {
      headers: {
        authorization: localStorage.getItem('token'),
      },
    },
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let timeOutId;
    if (isLoading) {
      (async () => {
        await new Promise((resolve, reject) => {
          timeOutId = setTimeout(() => {
            const token = localStorage.getItem('token');
            if (token) {
              allBooksInMyCart();
              getAllMyNotifications();
              setIsLoading(false);
            }
          }, 3000);
        });
      })();
    }

    return () => clearTimeout(timeOutId);
    //eslint-disable-next-line
  }, [isLoading]);

  useEffect(() => {
    searchRef?.current?.focus();
  }, []);

  const [searchInfo, SetSearchInfo] = useState({ search: '' });
  const [open, setOpen] = useState(false);
  const close = () => {
    setOpen(false);
    SetSearchInfo({ search: '' });
  };

  const onChangeHandler = e => {
    setOpen(false);
    SetSearchInfo({ search: e.target.value });
  };
  const onSubmitHandler = e => {
    e.preventDefault();
    if (e.key === 'Enter' || e.key === undefined) {
      setOpen(true);
    }
  };

  const handleLogout = () => {
    logout();
    setShow(false);
  };

  return (
    <>
      <div className="position-fixed top-0 w-100" style={{ zIndex: 101 }}>
        <div className="container-fluid text-white user-select-none " style={{ backgroundColor: '#010a17' }}>
          <div className="row">
            <div className="d-flex align-items-center justify-content-between flex-nowrap fw-bold fs-6 py-1">
              <div className="d-flex justify-content-start w-100 align-items-center flex-nowrap all-text-center">
                <IoPhonePortraitOutline size={20} className="text-white" data-toogle="tooltip" title="Call this number for assistance" />
                <span data-toogle="tooltip" title="Call this number for assistance">
                  (+250) 783185866
                </span>
                <RiMailSendLine size={20} className="text-white ms-4" />
                <span data-toogle="tooltip" title="Send an email for more assistance">
                  info@haapastore.com
                </span>
              </div>
              <div className="d-flex justify-content-end align-items-center flex-nowrap all-text-center hide-navbar-icon">
                <a href="https://www.instagram.com/haapastore?r=nametag" target="_blank" rel="noopener noreferrer" data-toggle="tooltip" title="Visit our instragram page">
                  <RiInstagramLine size={20} className="text-white me-3" />
                </a>
                <a href="https://www.twitter.com/haapastore" target="_blank" rel="noopener noreferrer" data-toggle="tooltip" title="Visit our twitter account">
                  <RiTwitterLine size={20} className="text-white me-3" />
                </a>
                <a href="https://www.facebook.com/haapastore" target="_blank" rel="noopener noreferrer" data-toggle="tooltip" title="Visit our facebook page">
                  <RiFacebookCircleLine size={20} className="text-white" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <Navbar bg="light" expand="lg" className="bg-gradient-0">
          <Container>
            <Navbar.Brand href="/">
              <img src={white_logo} alt="white logo" style={{ objectFit: 'cover' }} width={40} height={40} />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                {React.Children.toArray(
                  NavigationMenu?.map(menu => (
                    <Nav.Link className={`fs-6 fw-lighter ${menu.route === location.pathname ? 'text-orange-darken fw-bold' : 'text-white '}`} href={menu.route}>
                      {lang.t(`${menu.label}`)}
                    </Nav.Link>
                  )),
                )}
              </Nav>
              <Nav>
                <Nav.Item>
                  <div className="d-flex h-100 nav-link">
                    <SelectLanguage />
                  </div>
                </Nav.Item>

                <Nav.Item>
                  <div className="d-flex align-items-center h-100 nav-link">
                    <motion.div animate={{ height: 30 }} transition={{ duration: 0.5 }} className="d-flex align-items-center flex-nowrap w-100 bg-transparent border px-2 nav-link">
                      <input
                        className="fw-lighter fs-6 border-0 bg-transparent text-white w-100 me-1"
                        placeholder={lang.t('Search here') + '...'}
                        onKeyUp={e => onSubmitHandler(e)}
                        value={searchInfo.search}
                        onChange={e => onChangeHandler(e)}
                        ref={searchRef}
                        type="text"
                      />
                      <RiSearchLine size={15} className="text-white cursor-pointer" onClick={e => onSubmitHandler(e)} />
                    </motion.div>
                  </div>
                </Nav.Item>

                {!user ? (
                  <Nav.Item>
                    <div className="d-flex align-items-center flex-nowrap h-100 nav-link">
                      <motion.div whileHover={{ scale: 1.1 }} className="d-flex flex-nowrap align-items-center me-3 cursor-pointer" onClick={() => history.push('/auth/login')}>
                        <RiLoginCircleLine size={20} className="text-white me-1" />
                        <span className="text-white fs-6 fw-bold">{lang.t('Login')}</span>
                      </motion.div>
                      <motion.div
                        whileHover={{ scale: 1.1 }}
                        className="d-flex flex-nowrap align-items-center cursor-pointer ms-3 px-3 py-2 rounded-2 bg-white"
                        onClick={() => history.push('/auth/signup')}
                      >
                        <RiUserAddLine size={20} className="text-chocolate me-1" />
                        <span className="text-chocolate fs-6 fw-bold">{lang.t('Register')}</span>
                      </motion.div>
                    </div>
                  </Nav.Item>
                ) : (
                  <Nav.Item>
                    <div className="d-flex align-items-center flex-nowrap nav-link h-100">
                      <span className="d-flex align-items-center me-5 position-relative cursor-pointer">
                      {dataNotifications?.getAllMyNotifications.filter(notification => notification.isOpenned === false)?.length !== 0 ? ( 
                          <IoNotificationsOutline size={33} className="text-white" onClick={() => toggleNotification()}/>
                        ): (
                          <IoNotificationsOutline size={33} className="text-white"/>
                        )
                      }
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-orange-darken" style={{ fontSize: 11 }}>
                          {dataNotifications?.getAllMyNotifications?.length !== 0 ? dataNotifications?.getAllMyNotifications?.filter(msg => msg.isOpenned === false).length : 0}
                        </span>
                      </span>
                        
                      <div style={{position: 'absolute', marginTop: '60px', top:0, display: showAlert}}>
                        <Card border="danger" style={{ width: '18rem' }}>
                          <Card.Body>
                            <p><span className="closebtn" onClick={() => showNotification()}>&times;</span></p>
                            {dataNotifications && dataNotifications.getAllMyNotifications.length !== 0 ? (
                              dataNotifications.getAllMyNotifications
                              .map((notification, index) => (
                                <>
                                  {notification.isOpenned === false ?
                                    (
                                    <div
                                      className="notification-column-not-opened"
                                      key={index}
                                      onClick={() => history.push(`/notification/${notification.id}/message`)}
                                    >
                                      <p>
                                        <i className="envelope icon discount"></i> {notification.notificationBody.substr(0, 50) + '...'}
                                      </p>
                                      <div style={{color: 'gray' }}>
                                        <p>
                                          {moment(notification.createdAt).fromNow()}
                                          <b style={{ float: 'right' }}>~ Admin</b>
                                        </p>
                                      </div>
                                      <br />
                                    </div>
                                  ) :
                                  ('')
                                  }
                                </>
                                ))
                              ) :
                              (
                              <div>
                                <p style={{ color: 'rgb(128, 120, 120)' }}>
                                    You have no new notification!
                                </p>
                                <br />
                              </div>
                              )
                            }
                            <p><span onClick={() => showNotification()} style={{marginTop:'1px', color: 'red'}}>Close</span></p>
                          </Card.Body>
                        </Card>
                      </div>

                      <span className="d-flex align-items-center position-relative cursor-pointer" onClick={() => history.push(`/contents/cart/my-cart`)}>
                        <IoCartOutline size={33} className="text-white" />
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-orange-darken" style={{ fontSize: 11 }}>
                          {data?.allBooksInMyCart?.carts?.length !== 0 ? data?.allBooksInMyCart?.carts?.length : 0}
                        </span>
                      </span>

                      <div ref={ref}>
                        <div className="d-flex align-items-center justify-content-start flex-nowrap ms-5 cursor-pointer" onClick={handleClick}>
                          {user?.profile ? (
                            <Image src={user?.profile} style={{ height: 40, width: 40, objectFit: 'cover', borderRadius: 10 }} circular />
                          ) : (
                            <div className=" border border-2 rounded-3 p-1">
                              <FaRegUserCircle className="text-white" size={30} />
                            </div>
                          )}
                        </div>
                        <Overlay show={show} target={target} placement="bottom" container={ref.current} containerPadding={20}>
                          <Popover id="popover-contained" className="mt-1">
                            <PopoverContent>
                                <motion.div whileHover={{ scale: 1.1, color:'var(--orange-darken)' }} className="d-flex flex-nowrap justify-content-start align-items-center mx-3 py-3 cursor-pointer" 
                                  onClick={()=>history.push(`/auth/profile/${user?.username}`)}
                                >
                                  <RiShieldUserLine size={20} className="me-1" />
                                  <span className="fs-6 fw-bold">{lang.t('My profile')}</span>
                                </motion.div>
                                <motion.div 
                                  whileHover={{ scale: 1.1, color:'var(--orange-darken)'}} 
                                  className="d-flex flex-nowrap justify-content-start align-items-center mx-3 py-3 cursor-pointer"
                                  onClick={()=>history.push(`/dashboard/ui/${user?.username}`)}
                                >
                                  <RiDashboardLine size={20} className="me-1" />
                                  <span className="fs-6 fw-bold">{lang.t('Dashboard')}</span>
                                </motion.div>
                              <motion.div
                                whileHover={{ scale: 1.1, color:'var(--orange-darken)' }}
                                className="d-flex flex-nowrap justify-content-start align-items-center mx-3 py-3 cursor-pointer"
                                onClick={() => history.push(`/dashboard/ui/${user?.username}`, { state: { page: 2 } })}
                              >
                                <MdLibraryBooks size={20} className="me-1" />
                                <span className="fs-6 fw-bold">{lang.t('My Books')}</span>
                              </motion.div>
                              <motion.div
                                whileHover={{ scale: 1.1, color:'var(--orange-darken)' }}
                                className="d-flex flex-nowrap justify-content-start align-items-center mx-3 py-3 cursor-pointer"
                                onClick={() => history.push(`/dashboard/ui/${user?.username}`, { state: { page: 11 } })}
                              >
                                <RiBook3Line size={20} className="me-1" />
                                <span className="fs-6 fw-bold">{lang.t('All Books I Bought')}</span>
                              </motion.div>
                                <motion.div whileHover={{ scale: 1.1, color:'var(--orange-darken)' }} className="d-flex flex-nowrap justify-content-start align-items-center mx-3 py-3 cursor-pointer"
                                  onClick={()=>history.push("/contents/create/new")}
                                >
                                  <RiHealthBookLine size={20} className="me-1" />
                                  <span className="fs-6 fw-bold">{lang.t('Create new Book')}</span>
                                </motion.div>

                              <motion.div whileHover={{ scale: 1.1, color:'var(--orange-darken)' }} className="d-flex flex-nowrap justify-content-start align-items-center mx-3 py-3 cursor-pointer" onClick={handleLogout}>
                                <RiLogoutCircleLine size={20} className="me-1" />
                                <span className="fs-6 fw-bold">{lang.t('Logout')}</span>
                              </motion.div>
                            </PopoverContent>
                          </Popover>
                        </Overlay>
                      </div>
                    </div>
                  </Nav.Item>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        {open && <SearchModal close={close} open={open} setOpen={setOpen} text={searchInfo.search} />}
      </div>
    </>
  );
};

export default withTranslation()(MainHeader);
